import ls from 'local-storage'
import axios from 'axios'
import AuthService from '../AuthService'
import BaseService from '../BaseService'

export default class extends BaseService {
  static url(path) {
    return new URL(path, `${process.env.API_URL}/v2/`)
  }

  static get(url) {
    return this.request('get', url)
  }

  static request(requestType, url, data = null) {
    return this.authenticate()
      .then(user => this.refreshToken(user))
      .then(() => axios[requestType](url, data, { headers: { 'Content-Type': 'application/vnd.api+json' } }))
      .catch(error => Promise.reject(error))
  }

  static refreshToken(user) {
    axios.interceptors.response.use(response => {
      super.isTokenAlmostExpired(user.jwt)
      return response
    }, error => {
      console.log("Refresh token error", error)

      if (error.response.status === 401)
        logout()

      return Promise.reject(error)
    })
  }

  static authenticate() {
    const user = ls.get('user')

    if (_.has(user, 'jwt')) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${user.jwt.access_token}`
      return Promise.resolve(user)
    } else {
      return Promise.reject("User is not logged in")
    }
  }

  static logout() {
    AuthService.logout()
    window.location = '/'
  }
}
